import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitInfoTextExtensionInterface } from '../../../extension/interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { MobilityBenefitActivationDialogExtension } from './extension/mobility-benefit-activation-dialog.extension';
import { MobilityBenefitColumnsExtension } from './extension/mobility-benefit-columns.extension';
import { MobilityBenefitInfoTextExtension } from './extension/mobility-benefit-info-text.extension';
import { MobilityBenefitMetadataExtension } from './extension/mobility-benefit-metadata.extension';
import { MobilityBenefitNavigationExtension } from './extension/mobility-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('mobility')
    .add(BenefitMetadataExtensionInterface, new MobilityBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new MobilityBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new MobilityBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new MobilityBenefitActivationDialogExtension())
    .add(BenefitInfoTextExtensionInterface, new MobilityBenefitInfoTextExtension())
    .build(),
);
